import { Expense } from "@finway-group/shared/lib/models"
import HttpStatus from "http-status"
import { TFunction } from "i18next"

import i18n from "Shared/locales/i18n"

export interface ErrorInterface {
    response: ResponseInterface
    message: string
}
interface ResponseInterface {
    status: number
    data: {
        errors?: Array<{ msg: string }>
        error?: string
    }
}

export const extractErrors = ({ data: { errors, error } }: ResponseInterface) => {
    const extractedErrors: Array<string> = []
    if (Array.isArray(errors) && errors.length > 0) errors.forEach((e) => extractedErrors.push(e.msg))
    else if (error) extractedErrors.push(error)
    else extractedErrors.push(i18n.t("error:unknown"))
    return extractedErrors
}

export const isClientErrorCode = (err: any) => {
    if (err?.response?.status && err.response.status >= 400 && err.response.status < 500) {
        return true
    }
    return false
}

type ValidationErrorInfo = {
    location: string
    msg: string
    path: string
    type: string
    value: string
}

type ValidationErrorResponse = {
    status: number
    data: {
        errors: Array<ValidationErrorInfo>
    }
}

type ValidationError = {
    response: ValidationErrorResponse
}
export const checkIsValidationError = (err: unknown): err is ValidationError => {
    if (!err || typeof err !== "object") return false

    const response = "response" in (err as ValidationError) ? (err as ValidationError).response : undefined
    if (!response) return false

    return response && response.status === HttpStatus.BAD_REQUEST && response.data?.errors?.length > 0
}

export const getExpenseValidationErrorTip = (path: keyof Expense, t: TFunction) => {
    switch (path) {
        case "description":
        case "expenseAccount":
            return t("error:request.missing_field.must_be_added")
        default:
            return t("error:request.missing_field.must_be_adjusted")
    }
}
